import { SubmissionRanking } from 'models/ranking/submissionRanking/SubmissionRanking';

export class SubmissionRankingService {
	toModel(ranking) {
		return new SubmissionRanking(ranking);
	}
}
